import { Typography } from "@mui/material";

const TimelinePanel = () => <Typography sx={{ color: "text.secondary" }}>TODO: Timeline settings.</Typography>;

export default TimelinePanel;
